"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.medicalCodes = exports.noteList = exports.entries = exports.groups = exports.externalApplications = exports.rules = exports.invoices = exports.unstructuredHighlights = exports.timelineCases = exports.spans = exports.rawNote = exports.notes = exports.transformers = exports.tasks2 = exports.criteria = exports.stockPredictions = exports.submittedArtifacts = exports.metadataAssociations = exports.metadataSources = exports.cases = exports.caseList = exports.orgs = exports.metadata = exports.pageables = exports.user = exports.codeDescriptions = exports.contexts = exports.bpmStepsFixtures = exports.billingGroups = exports.formErrors = exports.artifactFixtures = exports.artifacts = exports.mappedOnly = exports.searchResults = exports.chargeSessionCodes = exports.sessionSelection = exports.imoCodeDescriptions = exports.loginPreferences = exports.pathCase = exports.providerSearchResult = exports.providers = exports.techCodeDescriptions = exports.systemActivity = exports.userActivity = exports.documents = exports.dictionaries = exports.amplify = exports.xcaliberEntities = exports.caseSearchResults = exports.ipcCases = void 0;
exports.getContextState = exports.CQAFixtures = void 0;
var contexts = __importStar(require("./fixtures/contexts"));
exports.contexts = contexts;
var cases = __importStar(require("./fixtures/case/case"));
exports.cases = cases;
var artifacts = __importStar(require("./fixtures/case/artifacts"));
exports.artifacts = artifacts;
var caseSearchResults = __importStar(require("./fixtures/case/search-result"));
exports.caseSearchResults = caseSearchResults;
var codeDescriptions = __importStar(require("./fixtures/case/code-descriptions"));
exports.codeDescriptions = codeDescriptions;
var orgs = __importStar(require("./fixtures/orgs"));
exports.orgs = orgs;
var pageables = __importStar(require("./fixtures/pageables"));
exports.pageables = pageables;
var user = __importStar(require("./fixtures/user"));
exports.user = user;
var metadata = __importStar(require("./fixtures/metadata-definitions"));
exports.metadata = metadata;
var transformers = __importStar(require("./fixtures/artifacts/transformers.fixtures"));
exports.transformers = transformers;
var metadataSources = __importStar(require("./fixtures/metadata-sources"));
exports.metadataSources = metadataSources;
var metadataAssociations = __importStar(require("./fixtures/metadata-association"));
exports.metadataAssociations = metadataAssociations;
var criteria = __importStar(require("./fixtures/criteria"));
exports.criteria = criteria;
var notes_1 = require("./fixtures/case/notes");
Object.defineProperty(exports, "notes", { enumerable: true, get: function () { return notes_1.notes; } });
Object.defineProperty(exports, "rawNote", { enumerable: true, get: function () { return notes_1.rawNote; } });
var tasks2 = __importStar(require("./fixtures/case/tasks-2"));
exports.tasks2 = tasks2;
var rules = __importStar(require("./fixtures/case/rule-evaluation-results"));
exports.rules = rules;
var submittedArtifacts = __importStar(require("./fixtures/artifacts/submitted-artifact"));
exports.submittedArtifacts = submittedArtifacts;
var stockPredictions = __importStar(require("./fixtures/stock-predictions"));
exports.stockPredictions = stockPredictions;
var billingGroups = __importStar(require("./fixtures/billing-groups"));
exports.billingGroups = billingGroups;
var spans = __importStar(require("./fixtures/case/spans"));
exports.spans = spans;
var unstructuredHighlights = __importStar(require("./fixtures/case/unstructured-highlights"));
exports.unstructuredHighlights = unstructuredHighlights;
var timelineCases = __importStar(require("./fixtures/steps/library"));
exports.timelineCases = timelineCases;
var bpmStepsFixtures = __importStar(require("./fixtures/bpm2"));
exports.bpmStepsFixtures = bpmStepsFixtures;
var invoices = __importStar(require("./fixtures/invoices/index"));
exports.invoices = invoices;
var externalApplications = __importStar(require("./fixtures/external-application"));
exports.externalApplications = externalApplications;
var groups = __importStar(require("./fixtures/groups"));
exports.groups = groups;
var loginPreferences = __importStar(require("./fixtures/login/preferences"));
exports.loginPreferences = loginPreferences;
var at_coder_fixture_1 = require("./fixtures/artifacts/at-coder.fixture");
var from_cac_fixtures_1 = require("./fixtures/artifacts/from-cac.fixtures");
var prediction_fixture_1 = require("./fixtures/artifacts/prediction.fixture");
var submitted_collection_fixture_1 = require("./fixtures/artifacts/submitted-collection.fixture");
var formErrors = __importStar(require("./fixtures/form-errors"));
exports.formErrors = formErrors;
var mapped_only_1 = require("./fixtures/mapped-only");
Object.defineProperty(exports, "mappedOnly", { enumerable: true, get: function () { return mapped_only_1.mappedOnly; } });
var charge_session_codes_1 = require("./fixtures/charge-session-codes");
Object.defineProperty(exports, "chargeSessionCodes", { enumerable: true, get: function () { return charge_session_codes_1.chargeSessionCodes; } });
var medicalCodes = __importStar(require("./fixtures/charge-session-codes"));
exports.medicalCodes = medicalCodes;
var code_search_results_1 = require("./fixtures/code-search-results");
Object.defineProperty(exports, "searchResults", { enumerable: true, get: function () { return code_search_results_1.searchResults; } });
var session_selection_1 = require("./fixtures/evidence2/session-selection");
Object.defineProperty(exports, "sessionSelection", { enumerable: true, get: function () { return session_selection_1.sessionSelection; } });
var code_descriptions_1 = require("./fixtures/code-descriptions");
Object.defineProperty(exports, "imoCodeDescriptions", { enumerable: true, get: function () { return code_descriptions_1.imoCodeDescriptions; } });
var providers_1 = require("./fixtures/providers/providers");
Object.defineProperty(exports, "providers", { enumerable: true, get: function () { return providers_1.providers; } });
var search_result_1 = require("./fixtures/providers/search-result");
Object.defineProperty(exports, "providerSearchResult", { enumerable: true, get: function () { return search_result_1.providerSearchResult; } });
var path_case_1 = require("./fixtures/case/path-case");
Object.defineProperty(exports, "pathCase", { enumerable: true, get: function () { return path_case_1.pathCase; } });
var entries_1 = require("./fixtures/case/entries");
Object.defineProperty(exports, "entries", { enumerable: true, get: function () { return entries_1.entries; } });
var tech_code_descriptions_1 = require("./fixtures/tech-code-descriptions");
Object.defineProperty(exports, "techCodeDescriptions", { enumerable: true, get: function () { return tech_code_descriptions_1.techCodeDescriptions; } });
var documents = __importStar(require("./fixtures/documents/index"));
exports.documents = documents;
var user_activity_1 = require("./fixtures/amplify/user-activity");
Object.defineProperty(exports, "userActivity", { enumerable: true, get: function () { return user_activity_1.userActivity; } });
var system_activity_1 = require("./fixtures/amplify/system-activity");
Object.defineProperty(exports, "systemActivity", { enumerable: true, get: function () { return system_activity_1.systemActivity; } });
var amplify = __importStar(require("./fixtures/amplify/index"));
exports.amplify = amplify;
var dictionaries = __importStar(require("./fixtures/dictionaries/index"));
exports.dictionaries = dictionaries;
var xcaliberEntities = __importStar(require("./fixtures/xcaliber/index"));
exports.xcaliberEntities = xcaliberEntities;
var ipcCases = __importStar(require("./fixtures/ipc/index"));
exports.ipcCases = ipcCases;
var coder_notes_1 = require("./fixtures/case/coder-notes");
Object.defineProperty(exports, "noteList", { enumerable: true, get: function () { return coder_notes_1.noteList; } });
var GradeableInvoice_1 = __importDefault(require("./fixtures/cqa/GradeableInvoice"));
var GradeableTransaction_1 = __importDefault(require("./fixtures/cqa/GradeableTransaction"));
var CQATaskCodes_1 = __importDefault(require("./fixtures/cqa/CQATaskCodes"));
var CQAOptions_1 = __importDefault(require("./fixtures/cqa/CQAOptions"));
var CQACodeBenchV2Props_1 = require("./fixtures/cqa/CQACodeBenchV2Props");
var index_1 = require("./fixtures/dictionaries/index");
var CQAActivity_1 = require("./fixtures/cqa/CQAActivity");
var CQAFixtures = {
    GradeableInvoiceFixtures: GradeableInvoice_1.default,
    GradeableTransactionFixtures: GradeableTransaction_1.default,
    CQATaskCodeFixtures: CQATaskCodes_1.default,
    CQAOptions: CQAOptions_1.default,
    RiskCategoryDictionaryResponses: index_1.RiskCategoryDictionaryResponses,
    getCQACodeBenchV2Props: CQACodeBenchV2Props_1.getCQACodeBenchV2Props,
    getCqaActivityMock: CQAActivity_1.getCqaActivityMock
};
exports.CQAFixtures = CQAFixtures;
var selections_fixtures_1 = require("./fixtures/artifacts/selections.fixtures");
var context_1 = require("./fixtures/userContext/context");
Object.defineProperty(exports, "getContextState", { enumerable: true, get: function () { return context_1.getContextState; } });
var artifactFixtures = {
    predictedArtifact: prediction_fixture_1.predictedArtifact,
    fromCAC: from_cac_fixtures_1.fromCAC,
    atCoder: at_coder_fixture_1.atCoder,
    multiSelect: selections_fixtures_1.multiSelect,
    multiDeselect: selections_fixtures_1.multiDeselect,
    m19Selection: selections_fixtures_1.m19Selection,
    m19Deselection: selections_fixtures_1.m19Deselection,
    m19SingleSelect: selections_fixtures_1.m19SingleSelect,
    m19SingleDeselect: selections_fixtures_1.m19SingleDeselect,
    submittedCollection: submitted_collection_fixture_1.submittedCollection
};
exports.artifactFixtures = artifactFixtures;
var caseList = [cases.multipleAutomated];
exports.caseList = caseList;
//# sourceMappingURL=index.js.map